import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import {
    Card,
    Table,
    Stack,
    Button,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    IconButton,
    TableContainer,
    CircularProgress,
    TableHead,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
// import USERLIST from '../_mock/user';
import SupplierModal from 'src/components/modal/SupplierModal';
import { useParams } from 'react-router-dom';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import AddButton from 'src/components/Button.js/AddBotton';
import { ButtonGroup } from 'react-bootstrap';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import { useDownloadExcel } from 'react-export-table-to-excel';
import Loader from 'src/components/loader/loader';
import * as XLSX from 'xlsx';
import CreateSupplierExcelModal from 'src/components/modal/CreateSupplierExcelModal';
// import { t } from 'i18next';
import imgDefault from '../image/default/logo.png';
import EmtyData from 'src/components/emty-data';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function Supplier() {
    const params = useParams();
    const [visibleDel, setVisibleDel] = useState(false);
    const { t } = useTranslation();
    const TABLE_HEAD = [
        { id: 'name', label: t('name_supplier'), alignRight: false },
        { id: 'company', label: t('code_supplier'), alignRight: false },
        { id: 'role', label: t('persitional'), alignRight: false },
        { id: 'isVerified', label: 'Email', alignRight: false },
        { id: 'status', label: t('phone_supplier'), alignRight: false },
        { id: 'address', label: t('address_supplier'), alignRight: false },
        { id: '1', label: t('producer'), alignRight: false },
        { id: '' },
    ];

    const TABLE_HEAD_EXCEL = [
        { id: 'company', label: t('code_supplier'), alignRight: false },
        { id: 'role', label: t('persitional'), alignRight: false },
        { id: 'isVerified', label: 'Email', alignRight: false },
        { id: 'status', label: t('phone_supplier'), alignRight: false },
        { id: 'address', label: t('address_supplier'), alignRight: false },
        { id: '1', label: t('producer'), alignRight: false },
        { id: 'name', label: t('name_supplier'), alignRight: false },
    ];
    const [getFlags, setGetFlags] = useState(false);
    const isEdit = useRef(false);
    const [tableData, setTableData] = useState([]);
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);

    const arrFillters = useRef([]);
    const [dataAction, setDataAction] = useState({});

    const [visible, setVisible] = useState(false);

    const getRef = useRef();

    const [checkDataExcel, setCheckDataExcel] = useState(false);
    const fileInputRef = useRef(null);
    const [dataExcel, setDataExcel] = useState([]);
    const [visibleExcel, setVisibleExcel] = useState(false);

    const tableRef = useRef(null);
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('quan_ly_nha_cung_cap'),
        sheet: t('quan_ly_nha_cung_cap'),
    });
    const [screenPermissions, setScreenPermissions] = useState({});

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [+params.idPermission, 9999999999999999999, ''];
        sendRequest(serviceList.getAllsupplierUser, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            arrFillters.current = message.proc_data.rows[0].o_1;
            setScreenPermissions(message.proc_data.rows[1].o_1[0][0]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };
    const handleDelete = () => {
        if (!dataAction.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = ['1', dataAction.id, +params.idPermission];
        sendRequest(serviceList.deletesupplier, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDel(false);
            getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const fillterSearcher = (value) => {
        if (value === '' || !value) {
            return setTableData(arrFillters.current);
        }
        const arrSearch = arrFillters.current.filter(
            (data) => data.supplier_nm.includes(value.toUpperCase()) || data.supplier_cd.includes(value.toUpperCase())
        );
        setTableData(arrSearch);
    };

    const handleFileUpload = (event) => {
        setDataExcel([]);
        deleteTableExcel();
        if (event.target.files.length > 0) {
            setCheckDataExcel(true);
            const file = fileInputRef.current.files[0];
            try {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    if (workbook.SheetNames.length > 0) {
                        // Lấy dữ liệu từ sheet đầu tiên
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        console.log(jsonData);
                        if (jsonData?.length > 0) {
                            jsonData.map((item, index) => {
                                console.log(item);
                                if (index !== 0)
                                    if (item.length === 7) {
                                        // Xử lý an toàn cho cột Nhà sản xuất (item[5])
                                        const producerVal = item[5] ? String(item[5]) : '';
                                        item[5] = producerVal
                                            .split(',')
                                            .filter((p) => p.trim() !== '')
                                            .map((p) => {
                                                return { label: p.trim(), value: generateUniqueId() };
                                            });
                                        item[5] = JSON.stringify(item[5]);
                                        item[3] = `${item[3] || ''}`;
                                        importExcel(item);
                                    } else {
                                        setTimeout(() => {
                                            toast.error(`${t('row_data')}${index} ${t('invalid')}`);
                                        }, index * 100 + 1000);
                                    }
                                // console.log(item);
                                if (index + 1 === jsonData.length) {
                                    // setTotalDataExcel(jsonData.length);
                                    setVisibleExcel(true);
                                }
                            });
                        } else {
                            toast.error(t('data_file_err'));
                        }
                    } else {
                        toast.error(t('file_excel_err'));
                    }
                    // In ra dữ liệu từ file Excel
                };

                reader.readAsArrayBuffer(file);
            } catch (error) {}
            setCheckDataExcel(false);
        } else {
        }
        fileInputRef.current.value = '';
    };

    // Đưa dữ liệu lên server
    const importExcel = (data) => {
        sendRequest(serviceList.uploadsupplier, data, importExcelResult, true, timeOutImport, 40000);
    };
    const importExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            const data = message.proc_data.rows;
            const newArr = dataExcel;
            newArr.push(data);
            setDataExcel(JSON.parse(JSON.stringify(newArr)));
        }
    };
    const timeOutImport = (reqInfo) => {};

    const deleteTableExcel = () => {
        const InVal = [];
        sendRequest(serviceList.deleteUploadsupplier, InVal, deleteExcelResult, true, timeOutDeleteTabbelExcel, 40000);
    };

    const deleteExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        }
    };
    const timeOutDeleteTabbelExcel = (reqInfo) => {};

    const generateUniqueId = () => {
        const uniqueId = Math.random().toString(36).substr(2, 9);
        return uniqueId;
    };

    return (
        <>
            <Helmet>
                <title> {t('quan_ly_nha_cung_cap')} </title>
            </Helmet>

            <Container>
                <CreateSupplierExcelModal
                    visible={visibleExcel}
                    dataExcel={dataExcel}
                    fuctGet={getData}
                    setDataExcel={setDataExcel}
                    setVisible={setVisibleExcel}
                />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" gutterBottom>
                        {t('quan_ly_nha_cung_cap')}
                    </Typography>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0} gap={1}>
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="mingcute:file-export-line" />}
                            onClick={onDownload}
                        >
                            {t('export_excel')}
                        </Button>
                        <label htmlFor="import" style={{ cursor: 'pointer' }}>
                            <Button
                                variant="contained"
                                disabled={checkDataExcel}
                                startIcon={<Iconify icon="mingcute:file-import-line" />}
                                // onClick={handleFileUpload}
                            >
                                <label htmlFor="import"> {t('import') + ' excel'}</label>{' '}
                                {checkDataExcel && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            color: 'red',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            marginTop: '-12px',
                                            marginLeft: '-12px',
                                        }}
                                    />
                                )}
                            </Button>
                        </label>{' '}
                        <input
                            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            type="file"
                            hidden
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                            id="import"
                            name="import"
                        />
                        <Button variant="contained" startIcon={<Iconify icon="mingcute:file-download-line" />}>
                            <a
                                style={{ textDecoration: 'none', color: 'white' }}
                                target="_blank"
                                download
                                to={`${glb_sv.urlDownloadFileExcel('ExampleSupplier.xlsx')}`}
                                href={`${glb_sv.urlDownloadFileExcel('ExampleSupplier.xlsx')}`}
                            >
                                {t('download_file')}
                            </a>
                        </Button>
                    </Stack>
                </Stack>
                <Loader loading={getFlags} />
                <SupplierModal
                    fuctGet={getData}
                    idPermission={params.idPermission}
                    setVisible={setVisible}
                    visible={visible}
                    isEdit={isEdit.current}
                    dataUpdate={dataAction}
                />

                <Card sx={{ padding: 2 }}>
                    <UserListToolbar getValue={fillterSearcher} />
                    <ConfirmModal
                        loading={deleleFlags}
                        visible={visibleDel}
                        setVisible={setVisibleDel}
                        handleDelete={handleDelete}
                    />

                    <TableContainer sx={{}}>
                        <Table>
                            <UserListHead headLabel={TABLE_HEAD} />
                            <TableBody>
                                {tableData.length > 0
                                    ? tableData.map((item, index) => {
                                          return (
                                              <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                                  <TableCell padding="checkbox"></TableCell>

                                                  <TableCell component="th" scope="row" padding="none">
                                                      <Stack direction="row" alignItems="center" spacing={2}>
                                                          <img
                                                              style={{
                                                                  width: '50px',
                                                                  height: '50px',
                                                                  borderRadius: '5px',
                                                                  // backgroundColor: '#999',
                                                              }}
                                                              src={
                                                                  item?.logo_supplier
                                                                      ? `${glb_sv.urlGetProductImage(
                                                                            item.logo_supplier
                                                                        )}`
                                                                      : imgDefault
                                                              }
                                                              alt=""
                                                          />
                                                          <Typography variant="subtitle2" noWrap>
                                                              {glb_sv.convertMultipleLanguages(item?.supplier_nm)}
                                                          </Typography>
                                                      </Stack>
                                                  </TableCell>
                                                  <TableCell align="left" sx={{ minWidth: '140px' }} width={200}>
                                                      {item.supplier_cd}
                                                  </TableCell>
                                                  <TableCell align="left" width={200}>
                                                      {glb_sv.convertMultipleLanguages(item.auth_rep)}
                                                  </TableCell>

                                                  <TableCell align="left">{item.email}</TableCell>
                                                  <TableCell align="left">{item.supplier_phone}</TableCell>
                                                  <TableCell align="left" sx={{ minWidth: '170px' }}>
                                                      {item.address}
                                                  </TableCell>
                                                  <TableCell align="left" sx={{ minWidth: '140px' }}>
                                                      {item?.producer?.length > 0 &&
                                                          item.producer.map((producer, idx) => {
                                                              let str = '';
                                                              str +=
                                                                  glb_sv.convertMultipleLanguages(producer.label) +
                                                                  ', ';
                                                              return str;
                                                          })}
                                                  </TableCell>
                                                  <TableCell align="right">
                                                      <ButtonGroup
                                                          variant="text"
                                                          aria-label="text button group"
                                                          style={{
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                          }}
                                                      >
                                                          {screenPermissions?.update_permission === '1' && (
                                                              <IconButton
                                                                  size="large"
                                                                  color={'warning'}
                                                                  onClick={() => {
                                                                      setDataAction(item);
                                                                      isEdit.current = true;
                                                                      setVisible(true);
                                                                  }}
                                                              >
                                                                  <Iconify icon={'eva:edit-fill'} />
                                                              </IconButton>
                                                          )}
                                                          {screenPermissions?.delete_permission === '1' && (
                                                              <IconButton
                                                                  size="large"
                                                                  color={'error'}
                                                                  onClick={() => {
                                                                      setDataAction(item);
                                                                      setVisibleDel(true);
                                                                  }}
                                                              >
                                                                  <Iconify icon={'eva:trash-2-outline'} />
                                                              </IconButton>
                                                          )}
                                                      </ButtonGroup>
                                                  </TableCell>
                                              </TableRow>
                                          );
                                      })
                                    : null}
                            </TableBody>
                        </Table>
                        {tableData.length === 0 && <EmtyData />}
                    </TableContainer>

                    <TableContainer>
                        <Table ref={tableRef} sx={{ display: 'none' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('code_supplier')}</TableCell>
                                    <TableCell>{t('persitional')}</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>{t('phone_supplier')}</TableCell>
                                    <TableCell>{t('address_supplier')}</TableCell>
                                    <TableCell>{t('producer')}</TableCell>
                                    <TableCell>{t('name_supplier')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        return (
                                            <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                                <TableCell align="left" sx={{ minWidth: '140px' }} width={200}>
                                                    {item.supplier_cd}
                                                </TableCell>
                                                <TableCell align="left" width={200}>
                                                    {item.auth_rep}
                                                </TableCell>
                                                <TableCell align="left">{item.email}</TableCell>
                                                <TableCell align="left">{item.supplier_phone}</TableCell>
                                                <TableCell align="left" sx={{ minWidth: '170px' }}>
                                                    {item.address}
                                                </TableCell>
                                                <TableCell align="left" sx={{ minWidth: '140px' }}>
                                                    {item?.producer?.length > 0 &&
                                                        item.producer.map((producer, idx) => {
                                                            let str = '';
                                                            str += producer.label + ', ';
                                                            return str;
                                                        })}
                                                </TableCell>

                                                <TableCell align="left">{item?.supplier_nm}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </Container>

            {/* <ProductCartWidget /> */}
            {screenPermissions?.insert_permission === '1' && tableData.length > 0 ? (
                <AddButton
                    onClick={() => {
                        isEdit.current = false;
                        setVisible(true);
                        setDataAction({});
                    }}
                />
            ) : (
                ''
            )}
            {tableData.length === 0 && (
                <AddButton
                    onClick={() => {
                        isEdit.current = false;
                        setVisible(true);
                        setDataAction({});
                    }}
                />
            )}
        </>
    );
}
